<mat-card class="selection-section">
  <div class="panel_sub_header">
      <span class="panel__header__title">   {{"CRC Pre & Post Shipment Observation List Setup" | translate | async}}</span>
  </div>
  <div class="select-observation-against">
    <div class="filter-select">
    <mat-form-field  class="filter-select">
      <mat-select  [(ngModel)]="selectedCustomerId" (selectionChange)="ChangeCustomer()" placeholder="{{ 'Customer' | translate | async}}">
          <mat-option *ngFor="let customer of customerList" [value]="customer.Id">
              {{ customer.Name }}
          </mat-option>
      </mat-select>
      </mat-form-field>

      <mat-form-field  class="filter-select">
        <mat-select  [(ngModel)]="selectedImplmentTypeId" (selectionChange)="ChangeImplmentType()" placeholder="{{ 'Implement Type' | translate | async}}">
            <mat-option *ngFor="let imp of implementTypeList" [value]="imp.Id">
                {{ imp.Name }}
            </mat-option>
        </mat-select>
        </mat-form-field>

        <mat-form-field  class="filter-select">
          <mat-select  [(ngModel)]="selectedInspectionType" (selectionChange)="loadImplementTypeAddtionalObservationList()" placeholder="{{ 'Inspection Types' | translate | async}}">
            <mat-option  [value]="0" >All </mat-option>
              <mat-option  [value]="1" > Pre-shipment Inspection </mat-option>
              <mat-option  [value]="7" > Ready to Ship Inspection </mat-option>
              <mat-option  [value]="3" > Arrival Repairer Inspection </mat-option>

          </mat-select>

          </mat-form-field>

          <!-- <section class="example-section">
            <mat-checkbox class="example-margin" [(ngModel)]="PreShipmenet" >Pre-shipment Inspection</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="PostShipment" >Ready to Ship Inspection</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="ArrivalRepair">Arrival Repairer Inspection</mat-checkbox>
          </section> -->
    </div>
    
  </div>
</mat-card>

<mat-card  *ngIf="selected" class = "observation-list-table">
  <div>
      <div>
          <div class="panel_sub_header">
              <span class="panel__header__title"> {{"List of Available Observation List for this Implement Type" | translate | async}}</span>
              <!-- <span class="panel__header__title"> {{selectedCustomer?.Name}}</span> -->
          </div>
            <panel class="no-padding table-panel">
              <!-- <div class="spinner">
                <mat-spinner diameter="30"></mat-spinner>
              </div> -->
              <table class="table table--full-width table--striped table--hover" >
                <thead>
                  <tr>
                    <th >{{'Observation Name' | translate | async}}</th>
                    <th>{{'Inspection Type' | translate | async}}</th>
                    <!-- <th>{{'Created Date' | translate | async}}</th> -->
                    <th>{{'Modified User' | translate | async}}</th>
                    <th>{{'Disabled' | translate | async}}</th>
                    <th>{{'Edit' | translate | async}}</th>
                    <th><button mat-raised-button color="warn" (click)="addNewObservationListOnCustomer()"> <i  class="material-icons">add</i> {{"Add New" | translate | async}} </button></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let model of ImplementTypeLevelObservationList">
                    <td>  <div> {{ model.Title }} </div></td>
                    <td>  <div> {{ model.InspectionTypeName }} </div></td>
                    <td>  <div> {{ model.CreateduserName }} </div></td>

                    <td> <div> {{model.Active ? "Active" : "Disabled"}} </div></td>
                    <td> <div>  <button mat-stroked-button color="primary" (click)="editObservation(model)" > {{"Edit Observation" | translate | async}}</button> </div></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </panel>
          </div>

       


    </div>

</mat-card>

